<!--<div class="section intro">-->
<!--    <button mat-raised-button color="default" [routerLink]="'/' + organization?.code + '/athletes/' + athlete?.id + '/tests'">{{ 'TestsAll' | translate }}</button>-->
<!--</div>-->
<ng-container>
  <mat-list>
    <mat-list-item [matMenuTriggerFor]="menu" *ngIf="!activeTestId">
      <div class="test-group-item">
        <div class="test-name-group">
          <h3 mat-line>{{ 'TestsAll' | translate }}</h3>
          <p mat-line class="side-list-itme-sub-title">{{ 'All_tests_displayed' | translate }}</p>
        </div>
        <mat-icon class="icon-button mat-24">arrow_drop_down</mat-icon>
      </div>
    </mat-list-item>
    <ng-container *ngFor="let test of tests">
      <mat-list-item [matMenuTriggerFor]="menu" *ngIf="test.id === activeTestId">
        <div class="test-group-item">
          <div class="test-name-group">
            <h3 mat-line>{{ test.name }}</h3>
            <p mat-line class="side-list-itme-sub-title">{{ test.date | appDate:'mediumDate' | default:'-' }}</p>
          </div>
          <mat-icon class="icon-button mat-24">arrow_drop_down</mat-icon>
        </div>
      </mat-list-item>
    </ng-container>
  </mat-list>
  <mat-menu #menu="matMenu">
    <mat-list>
      <a [routerLink]="'/' + organization.code + '/app/athletes/' + athleteUser.id + '/tests'"
         class="side-list-item rootitem"
         mat-list-item>
        <h3 mat-line>{{ 'TestsAll' | translate }}</h3>
        <p mat-line class="side-list-itme-sub-title">{{ 'All_tests_displayed' | translate }}</p>
        <mat-divider [inset]="true"></mat-divider>
      </a>

      <ng-container *ngFor="let test of tests">
        <a [routerLink]="'/' + organization.code + '/app/athletes/' + athleteUser.id + '/tests/' + test.id"
           mat-list-item
           class="side-list-item">
          <h3 mat-line>{{ test.name }}</h3>
          <p mat-line class="side-list-itme-sub-title">{{ test.date | appDate:'mediumDate' | default:'-' }}</p>
          <mat-divider [inset]="true"></mat-divider>
        </a>
      </ng-container>
    </mat-list>
  </mat-menu>
</ng-container>
